import { render, staticRenderFns } from "./investment-maturity-filter.vue?vue&type=template&id=3a2b3a46"
import script from "./investment-maturity-filter.vue?vue&type=script&lang=js"
export * from "./investment-maturity-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports